<template>
  <div class="dim" id="pop-policy1" style="display: block">
    <div class="popup-policy">
      <h2>비밀번호 변경</h2>
      <button class="btn-x" @click="fnClose"></button>
      <section
        class="password"
        style="
          display: flex;
          justify-content: center;
          padding: 86px 60px 192px 60px;
        "
      >
        <dl class="info-txt" style="width: 100%">
          <dt>현재 비밀번호</dt>
          <dd>
            <input type="password" v-model="oldPassword" />
          </dd>

          <dt>변경할 비밀번호</dt>
          <dd>
            <input type="password" v-model="newPassword" />
          </dd>

          <dt>비밀번호 확인</dt>
          <dd>
            <input type="password" v-model="confirmPassword" />
          </dd>
        </dl>
      </section>
      <section class="foot-btn">
        <button @click="fnSave">변경하기</button>
      </section>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, getCurrentInstance } from 'vue'

export default {
  name: 'modal-password-client',
  description: '',
  props: {
    index: {
      type: [Number],
      default: 0
    },
    layout: {
      type: [Object],
      default: () => {}
    },
    data: {
      type: [Object],
      default: () => {}
    },
    callBack: {
      type: [Function],
      default: () => {}
    }
  },
  setup(props, context) {
    const { proxy } = getCurrentInstance()

    console.log(proxy)

    const state = reactive({
      oldPassword: '',
      newPassword: '',
      confirmPassword: ''
    })

    const fnClose = () => {
      context.emit('close', props.index)
    }
    const fnSave = async () => {
      if (!fnValid()) {
        return false
      }
      try {
        const res = await proxy.$InfoSvc.patchMapPassword(state)
        if (res.code === 1) {
          fnClose()
        } else {
          alert(res.message)
        }
      } catch (error) {
        alert(error?.data?.message || error?.message || 'Password change failed.')
      }
    }
    const fnValid = () => {
      if (proxy.$Util.isEmpty(state.oldPassword)) {
        alert('비밀번호를 입력해주세요.')
        return false
      }
      if (proxy.$Util.isEmpty(state.newPassword)) {
        alert('변경할 비밀번호를 입력해주세요.')
        return false
      }
      if (proxy.$Util.isEmpty(state.confirmPassword)) {
        alert('변경할 비밀번호를 입력해주세요.')
        return false
      }
      if (state.newPassword !== state.confirmPassword) {
        alert('변경할 비밀번호가 일치하지 않습니다.')
        return false
      }
      return true
    }

    return {
      fnClose,
      fnSave,
      fnValid,
      ...toRefs(state)
    }
  }
}
</script>

<style scoped></style>
